export const SETUP_PAYWALL = 'SETUP_PAYWALL';

export const setupPaywall = (clientID, eventEmitter, options = {}) => {
    return {
        type: SETUP_PAYWALL,
        data: {
            clientID,
            eventEmitter,
            options,
            //todo - fetch payment method instead of hard coding it..
            paymentMethod: 1,
        },
    };
};

export const EMIT_EVENT = 'EMIT_EVENT';
export const EVENT_SUCCESS = 'EVENT_SUCCESS';
export const EVENT_FAILURE = 'EVENT_FAILURE';

export const emitEvent = (event, ...args) => {
    return (dispatch, getState) => {
        dispatch({ type: EMIT_EVENT, event: { ...args } });

        const eventEmitter = getState().paywall.eventEmitter;
        if (eventEmitter) {
            const hadListener = eventEmitter(event, ...args);
            if (event === 'unrecoverable_error' && !hadListener) {
                dispatch({ type: EVENT_FAILURE, event: { ...args } });
            } else {
                dispatch({ type: EVENT_SUCCESS, event: { ...args } });
            }
        }
    };
};



// WEBPACK FOOTER //
// ./src/actions/paywall.js